import { createRouter, createWebHistory } from "vue-router";
import HomeView from "../views/HomeView.vue";
import { resetSmoothScroll } from "../assets/scrollsmooth.js";

const routes = [
  {
    path: "/",
    name: "home",
    component: HomeView,
  },
  {
    path: "/bagues",
    name: "bagues Joillerie",
    component: () => import("../views/BaguesView.vue"),
  },
  {
    path: "/baguesAcier",
    name: "bagues acier",
    component: () => import("../views/BaguesAcierView.vue"),
  },
  {
    path: "/chronographes",
    name: "chronographes",
    component: () => import("../views/ChronoView.vue"),
  },
  {
    path: "/history",
    name: "history",
    component: () => import("../views/HistoryView.vue"),
  },
  {
    path: "/contact",
    name: "contact",
    component: () => import("../views/ContactView.vue"),
  },
  {
    path: "/watch/:collectionId/:watchRef",
    name: "WatchDetail",
    component: () => import("../views/WatchDetail.vue"),
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

// Reset ScrollSmoother & ScrollTrigger après chaque navigation
router.afterEach(() => {
  resetSmoothScroll();
});

export default router;
